<div class="chart">
  <mat-form-field class="select-field" appearance="fill">
    <mat-label>{{ 'graph_select_indicator' | translate }}</mat-label>
    <mat-select panelClass="indicator-select-panel" class="select" (selectionChange)="selectIndicatorChange($event.value)">
      <mat-option *ngFor="let i of indicators" [value]="i.indicatorId"> {{ i?.displayName | localizedLabel: 'indicator' : i?.code }} [{{ i?.code }}] </mat-option>
    </mat-select>
  </mat-form-field>
  <mat-form-field class="select-field" appearance="fill">
    <mat-label>{{ 'graph_select_solution' | translate }}</mat-label>
    <mat-select class="select" (selectionChange)="selectSolutionChange($event.value)">
      <mat-option *ngFor="let s of projectData.solutionsEcoPro" [value]="s.solutionEcoProId">
        {{ s?.displayName }}
      </mat-option>
    </mat-select>
  </mat-form-field>

  <highcharts-chart appAutoReflow class="chart-graph" *ngIf="indicatorComparatif.indicatorId && solutionComparatif.solutionEcoProId" [Highcharts]="Highcharts" [options]="chartOptions" [(update)]="updateFlag" [oneToOne]="true"> </highcharts-chart>
</div>
